import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ValueBento } from "@/components/ValueBento";
import { Simulator } from "@/components/Simulator";
import { HowItWorks } from "@/components/HowItWorks";
import { Hardware } from "@/components/Hardware";
import { Gallery } from "@/components/Gallery";
import { AiTeaser } from "@/components/AiTeaser";
import { QuoteSection } from "@/components/QuoteSection";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen overflow-x-clip bg-cream text-ink">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ValueBento />
        <Simulator />
        <HowItWorks />
        <Hardware />
        <Gallery />
        <AiTeaser />
        <QuoteSection />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
